import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import classnames from 'clsx'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Clickable from 'components/Common/Clickable'

const Container = styled(Clickable)`
  position: relative;
  display: flex;
  align-items: center;
  max-height: ${rem(48)};
  justify-content: center;
  transition: background-color .2s;
  width: 100%;
  background-color: ${props => props.theme.palette.neutral.eight};
  border: 1px solid ${props => props.theme.palette.neutral.five};
  border-radius: ${props => props.theme.borderRadius.small};

  &.dateType {
    ${mediaQueryUp.tablet} {
      flex: 33;
    }

    ${mediaQueryUp.desktop} {
      flex: 27;
    }
  }

  &.occupancyType {
    ${mediaQueryUp.tablet} {
      flex: 25;
    }

    ${mediaQueryUp.desktop} {
      flex: 23;
    }
  }

  &.error {
    background: ${props => props.theme.palette.messaging.critical.light};
  }

  ${mediaQueryUp.tablet} {
    justify-content: flex-start;
    align-items: flex-start;

    margin-top: 0;
    padding-bottom: 0;
    padding-top: 0;
  }
`

const Content = styled.span`
  display: flex;
  align-items: center;
  height: ${rem(48)};
  width: 100%;
  padding: ${rem(4)};

  ${mediaQueryUp.tablet} {
    display: inline-flex;
  }
`

interface Props {
  children: React.ReactNode;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  isToggled?: boolean;
  error?: boolean;
  type?: string;
}

function SearchInputTrigger({ children, onClick, isToggled, error, type, className }: Props) {
  const [classname, setClassname] = useState<string | undefined>(undefined)

  useEffect(() => {
    // moved this logic into a use effect to fix ssr mismatch
    const dynamicClassname = classnames(className, {
      focused: isToggled,
      error,
      [`${type}Type`]: type,
    })
    setClassname(dynamicClassname)
  }, [className, error, isToggled, type])

  let dataTestId = ''
  if (type) {
    dataTestId = `search-${type}-input`
  }

  return (
    <Container
      onClick={onClick}
      className={classname}
      data-testid={dataTestId}
    >
      <Content>
        {children}
      </Content>
    </Container>
  )
}

export default SearchInputTrigger
